<template>
    <div class="content-box">
        <div class="data-overview">
            <div class="data-overview__statistics">
                <!--<div class="statistics-item">{{project_name}}</div>-->
                <!--                    <el-select v-model="selectedItem" placeholder="请选择付款项目">-->
                <!--                        <el-option-->
                <!--                            v-for="item in items"-->
                <!--                            :key="item.no"-->
                <!--                            :label="item.name"-->
                <!--                            :value="item.id">-->
                <!--                        </el-option>-->
                <!--                    </el-select>-->
                <div class="statistics-item"><span class="text-primary">共计 {{total}}笔 - {{total_money}}元</span></div>
            </div>
            <div class="table-box__tool">
                <el-button type="primary" @click="queryImport">确认导入</el-button>
                <el-button plain @click="goPage('/index/pay')">取消</el-button>
            </div>
        </div>
        <div class="overview">
            <div class="overview-box">
                <div class="content">
                    <div class="desc">校验成功 (笔·元)</div>
                    <div class="bd">{{members.length}} · {{settlement_money}}</div>
                </div>
                <div class="icon">
                    <v-svg-icon name="icon-icon_xiaoyanchenggong" class="check__icon"/>
                </div>
            </div>
            <div class="overview-box">
                <div class="content">
                    <div class="desc">校验失败 (笔·元)</div>
                    <div class="bd">{{errMembers.length}} · {{errMoney}}</div>
                </div>
                <div class="icon">
                    <v-svg-icon name="icon-icon_xiaoyanshibai" class="check__icon"/>
                </div>
            </div>
            <div class="overview-box">
                <div class="content">
                    <div class="desc">服务费 (元)</div>
                    <div class="bd">{{service_fee}}</div>
                </div>
                <div class="icon">
                    <v-svg-icon name="icon-icon_fuwufei" class="check__icon"/>
                </div>
            </div>
            <div class="overview-box">
                <div class="content">
                    <div class="desc">代缴合计 (元)</div>
                    <div class="bd">{{tax}}</div>
                </div>
                <div class="icon">
                    <v-svg-icon name="icon-icon_daizheng" class="check__icon"/>
                </div>
            </div>
        </div>
        <div class="table">
            <el-table
                :data="allData"
            >
                <el-table-column
                    prop="name"
                    align="center"
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="idcard"
                    align="center"
                    label="身份证号">
                </el-table-column>
                <el-table-column
                    prop="money"
                    align="center"
                    label="结算金额">
                </el-table-column>
                <el-table-column
                    prop="price"
                    align="center"
                    label="工时费用">
                </el-table-column>
                <el-table-column
                    prop="hour"
                    align="center"
                    label="工时">
                </el-table-column>
                <el-table-column
                    prop="tax"
                    align="center"
                    label="代缴个税">
                </el-table-column>
                <el-table-column
                    prop="real_money"
                    align="center"
                    label="实发金额">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="校验异常">
                    <template slot-scope="scope">
                        <span class="text-danger">{{scope.row.error_msg}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.error_msg !== ''" type="text" @click="removeRow(scope.row.no)"
                                   size="medium">移除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import qs from 'qs'
import router from '@/router'

export default {
    name: 'Step2',
    inject: ['back', 'goPage', 'tel'],
    data () {
        return {
            total: 0, // 总付款比数
            total_money: 0, // 总付款金额
            score: 0, // 成功校验比数
            settlement_money: 0, // 成功校验结算金额
            service_fee: 0, // 服务费
            tax: 0, // 个税
            fail: 0, // 校验异常比数
            fail_money: 0,
            errMembers: [],
            members: [],
            signStatus: ['待认证', '待签约', '已签约']
        }
    },
    mounted () {
        // this.getItems()
        this.resoveExcel(this.$route.query.path)
    },
    computed: {
        allData () {
            return [...this.errMembers, ...this.members]
        },
        errMoney () {
            let a = 0
            this.errMembers.forEach((item) => {
                a += (item.money * 1)
            })
            return a.toFixed(2)
        }
    },
    methods: {
        queryImport () {
            if (this.errMembers.length !== 0) {
                this.$message.error('请先移除异常项')
            } else if (this.members.length === 0) {
                this.$message.error('导入的项不能为空')
            } else {
                this.$http.post('/api/user/payment/confirm', qs.stringify({
                    list: JSON.stringify(this.members),
                    score: this.score,
                    settlement_money: this.settlement_money,
                    service_fee: this.service_fee,
                    tax: this.tax
                }))
                    .then(res => {
                        if (res.code === 0) {
                            localStorage.removeItem('CURRENT_ORDER')
                            localStorage.setItem('CURRENT_ORDER', JSON.stringify(res.data))
                            router.push('/index/pay/home/step3')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }
        },
        removeRow (e) {
            this.errMembers = this.errMembers.filter(({ no }) => no !== e)
        },
        resoveExcel (path) {
            this.$http.post('/api/user/payment/import', qs.stringify({
                path
            }))
                .then(res => {
                    if (res.code === 0) {
                        this.members = res.data.listData
                        this.errMembers = res.data.errorData
                        this.total = res.data.total // 总付款比数
                        this.total_money = res.data.total_money // 总付款金额
                        this.score = res.data.score // 成功校验比数
                        this.settlement_money = res.data.settlement_money // 成功校验结算金额
                        this.service_fee = res.data.service_fee // 服务费
                        this.tax = res.data.tax // 个税
                        this.fail = res.data.fail // 校验异常比数
                        this.fail_money = res.data.fail_money // 校验异常结算金额
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    @import "../../assets/style/sub.scss";

    .data-overview {
        height: 78px;
        border-bottom: 1px solid $--color-info-lighter;

        .data-overview__statistics {
            font-size: 20px;
            font-weight: bold;
        }
    }

    .overview {
        display: flex;
        padding: 0 30px;

        .overview-box {
            flex: 1;
            padding: 0 25px 0 30px;
            margin: 23px 0;
            display: flex;
            align-items: center;
            border-right: 1px solid $--color-info_lighter;
            position: relative;

            &::before {
                content: "";
                width: 0;
                height: 0;
                border-top: 5px solid transparent;
                border-left: 10px solid $--color-primary;
                border-bottom: 5px solid transparent;
                position: absolute;
                top: 3px;
                left: 13px;
            }

            &:last-child {
                border-width: 0;
            }

            .content {
                flex: 1;

                .desc {
                    color: $--color-info;
                    font-weight: 500;
                    margin-bottom: 10px;
                }

                .bd {
                    font-family: Arial;
                    font-size: 20px;
                    color: #333;
                }
            }

            .icon {
                width: 44px;
            }

            .check__icon {
                font-size: 44px;
            }
        }
    }
</style>
